<template>
    <div>
        <!-- <v-row>
            <v-col>
                <h4 class="mb-5">{{ trans('rules.simulation.title') }}</h4>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col>
                <p class="font-italic" v-if="slot">
                    {{ trans('common.slots_number') }}:
                    <span class="font-weight-bold">{{ slot.slots_number }}</span>
                      -  {{ trans('common.range_hour') }}:
                    <span class="font-weight-bold">{{ slot.range_hour }}</span>
                    => <span class="font-weight-bold">{{ minutes }}'</span>
                    <br> {{ trans('simulations.fields.item') }}:
                    <span class="font-weight-bold">{{ trans('simulations.fields.' + slot.item) }}</span>
                </p>
            </v-col>
        </v-row>
        <v-row v-if="slot">
            <v-col>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="computedDateFormattedMomentjs"
                            :label="trans('simulations.date')"
                            outlined
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        @input="menu = false"
                        locale="it"
                        :show-adjacent-months=true
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col>
                <v-select v-model.lazy="calendar.first_time" :items="hours" :label="trans('simulations.hour')" outlined></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet :height="calendar.height">
                    <v-calendar
                        color="primary"
                        type="day"
                        :hide-header=true
                        locale="it"
                        :interval-count="calendar.interval_count"
                        :interval-minutes="calendar.interval_minutes"
                        :first-time="calendar.first_time"
                        :interval-height="calendar.interval_height"
                        :events="events"
                        >
                        <template v-slot:event="{ event }">
                            <h4 class="text-center">{{ event.file + ' | ' + event.name }}</h4>
                        </template>
                    </v-calendar>
                </v-sheet>
            </v-col>
        </v-row>
    </div>
</template>
<script>

export default {
    name: "simulation",
    props: {
        assign: Object,
        rule: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            windowHeight: 0,
            date: new Date().toISOString().split('T')[0],
            menu: false,
            hours: [],
            calendar: {
                first_time: '08:00',
                interval_minutes: 10, //a quanti minuti una sezione
                height: 0,
                interval_count: 0,
                interval_height: 0,
            },
            slot: null,
            minutes: 0,
            events: [],
        }
    },
    mounted() {
        var start = moment({
            hour: '06',
            minute: '00'
        });
        var end = moment({
            hour: '23',
            minute: '00'
        });
        while (start <= end) {
            this.hours.push(start.format("HH:ss"));
            start.add(1, "h");
        }
        this.getSlot();
        this.handleResize();
    },
    watch: {
        'assign.point'() {
            this.getSlot();
            this.getEvents();
            this.setCalendar();
        },
        'date'() {
            this.getEvents();
        }
    },
    methods: {
        getSlot() {
            if (this.assign.point !== null) {
                axios.get('/points/slot/' + this.assign.point.id)
                    .then(response => {
                        this.slot = response.data;
                        this.minutes = (this.slot.range_hour * 60) / this.slot.slots_number;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
        setCalendar() {
            this.calendar.height = this.windowHeight - 400;
            //this.calendar.interval_height = this.calendar.height / (60 / this.calendar.interval_minutes); //altezza = altezza v-sheet / interval-count => per evitare lo scroll
            this.calendar.interval_height = 200;
            if (this.slot !== null) {
                this.calendar.interval_count = ((60 * this.slot.range_hour) / this.calendar.interval_minutes) + 1; //quante sezioni mostrare
            }
        },
        handleResize() {
            this.windowHeight = window.innerHeight;
            this.setCalendar();
        },
        getEvents() {
            axios.post('/simulate/' + this.assign.point.id, {
                'slot': this.slot,
                'rule': this.rule,
                'date': this.date,
            })
                .then(response => {
                    this.events = response.data;
                })
                .catch(e => {
                    console.log(e);
                });
        }
    },
    computed: {
        computedDateFormattedMomentjs () {
            return this.date ? moment(this.date).format('D MMMM YYYY') : ''
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
}
</script>
